export default "__VITE_ASSET__DvpFmVbk__"